<template>

    <div>

		<el-row class="mb-3" v-if="formularioConfirmarDireccion">
            <el-col :span="24">
                <p class="comfy-text s-16">Es necesario que nos confirmes los siguientes datos para validar la dirección en donde se prestará el servicio:</p>
            </el-col>
			<el-col :span="24">
				<div class="form-group mb-2">
					<i class="icon-location_city"></i>
					<label>Indícanos si es necesario el uso de ascensor</label>
					<el-select v-model="ascensor" size="large" class="w-100">
						<el-option label="Sí, tenemos ascensor" value="si"></el-option>
						<el-option label="No, no tenemos ascensor. (Sin costo adicional)." value="no_necesario"></el-option>
					</el-select>
				</div>
				<div class="form-group mb-2">
					<i class="icon-location_city"></i>
					<label>Indícanos si cuentas con parqueadero gratuito</label>
					<el-select v-model="parqueadero" size="large" class="w-100">
						<el-option label="No, no tengo parqueadero gratuito. (Sobrecosto de $10.000)." value="no" selected></el-option>
						<el-option label="Sí, tengo parqueadero gratuito" value="si"></el-option>
					</el-select>
				</div>
				<div class="form-group">
					<button class="btn btn-sm btn-block comfy rounded-big cursor-pointer text-white" @click="guardarDatosDireccion">Guardar datos</button>
				</div>
			</el-col>
		</el-row>
    </div>

</template>

<script>

	export default {
        props: [
            'datosDireccion',
        ],
        data() {
            return {
				parqueadero: 'no',
				ascensor: 'no_necesario',
				formularioConfirmarDireccion: false
            }
        },
        watch: {
			// 'datosDireccion.parqueadero': function(val, oldVal){
			// 	if(!this.datosDireccion.parqueadero || !this.datosDireccion.ascensor){
			// 		openModalDireccion()
			// 	}else{
			// 		this.formularioConfirmarDireccion = false
			// 	}
			// },
        },
        methods: {
			openModalDireccion(){
				// console.log('--- modal configurar direccion ---')
				this.formularioConfirmarDireccion = true
			},
			confirmarDatosDireccion(){
				if(!this.datosDireccion.parqueadero || !this.datosDireccion.ascensor){
					this.openModalDireccion()
				}else{
					this.formularioConfirmarDireccion = false
				}
			},
			guardarDatosDireccion(){
				// console.log('--- guardar datos direccion ---')
				if(!this.parqueadero || !this.ascensor){
					return
				}
				var url = '/cliente/actualizar-direccion-parqueadero'
				axios.post(url, {
					address_id: this.datosDireccion.direccion,
					parqueadero: this.parqueadero,
					ascensor: this.ascensor
				}).then(response => {
					// console.log(response.data)
					this.formularioConfirmarDireccion = false
					let params = {
						parqueadero: response.data.parqueadero,
						ascensor: response.data.ascensor,
						valorParqueadero: response.data.valorParqueadero,
						valorAscensor: response.data.valorAscensor
					}
					this.$emit('datosDireccion', params)
				}).catch(error => {
					console.log(error)
				})
			}
        },
        mounted() {
            // console.log('--- componente datos adicionales direccion ---')
            this.confirmarDatosDireccion()
        }
    }
</script>